export default __webpack_public_path__ + "static/media/gallery-32.39e09af2.jpg";